class Login {
	constructor(selector = ".login form") {
		this.form = document.querySelector(selector)

		this.init()
	}

	init() {
		if (!this.form) {
			return
		}

		this.bindFieldFocus()
	}

	bindFieldFocus() {
		this.form.querySelectorAll("input").forEach(input => {
			input.addEventListener("focus", () => {
				this.toggleFieldState(input, true)
			})

			input.addEventListener("blur", () => {
				this.toggleFieldState(input, false)
			})
		})
	}

	toggleFieldState(input, isFocused) {
		input.closest("p, .user-pass-wrap")?.classList.toggle("is-focused", isFocused)
	}
}

export default Login